export default __webpack_public_path__ + "static/media/terriblecycle.6504be22.PNG";